module.exports = __webpack_public_path__ + "static/media/assetstore.20116098.png";